import { useState } from "react";
import { WORLD_CUP_OFFICIAL_LOGO, WORLD_CUP_FALLBACK_LOGO } from "@/lib/worldCup2026";
import { cn } from "@/lib/utils";

interface WorldCupLogoProps {
  size?: number;
  className?: string;
  decorative?: boolean;
}

/**
 * Official FIFA World Cup 2026 emblem with a graceful fallback to the
 * API-Football generic icon if the primary CDN URL fails.
 */
export function WorldCupLogo({ size = 24, className, decorative = false }: WorldCupLogoProps) {
  const [src, setSrc] = useState(WORLD_CUP_OFFICIAL_LOGO);
  return (
    <img
      src={src}
      alt={decorative ? "" : "FIFA World Cup 2026"}
      aria-hidden={decorative || undefined}
      width={size}
      height={size}
      onError={() => {
        if (src !== WORLD_CUP_FALLBACK_LOGO) setSrc(WORLD_CUP_FALLBACK_LOGO);
      }}
      className={cn("object-contain shrink-0 select-none", className)}
      style={{ width: size, height: size }}
      loading="lazy"
      draggable={false}
    />
  );
}
